<div class="ad-settings__header">
  <admin-breadcrumbs></admin-breadcrumbs>

  <h3>Advanced Directive Settings</h3>
</div>

<div class="ad-settings__body">

  <div class="ad-settings__general-error" *ngIf="generalError">{{ generalError }}</div>
  <div class="ad-settings__success" *ngIf="successMsg">{{ successMsg }}</div>

  <ng-container *ngIf="!dataLoading; else loadingTpl">
    <div class="ad-settings__form">

      <!-- ======= Inference Rules ======= -->
      <section class="ad-settings__section">
        <h4 class="ad-settings__section-title">Inference Rules</h4>
        <p class="ad-settings__section-description">
          These rules control how the Advanced Directives report interprets PCC orders that only mention one side
          of the code status (e.g. only DNR, only DNI). They fill in the other question before comparing to the
          scanned POLST / MOLST document.
        </p>

        <div class="ad-settings__row">
          <label class="ad-settings__label">When PCC has DNR only, set Intubation to:</label>
          <form-field
            class="ad-settings__field"
            [config]="DNR_ONLY_INTUBATION_CONFIG"
            [value]="settings.dnrOnly_intubation"
            (onChange)="onDnrOnlyIntubationChange($event)">
          </form-field>
        </div>

        <div class="ad-settings__row">
          <label class="ad-settings__label">When PCC has DNI only, set CPR to:</label>
          <form-field
            class="ad-settings__field"
            [config]="DNI_ONLY_CPR_CONFIG"
            [value]="settings.dniOnly_cpr"
            (onChange)="onDniOnlyCprChange($event)">
          </form-field>
        </div>
      </section>

      <!-- ======= Scheduled Notifications ======= -->
      <section class="ad-settings__section">
        <h4 class="ad-settings__section-title">Scheduled Notifications</h4>
        <p class="ad-settings__section-description">
          Schedule recurring email delivery of the Advanced Directives report and choose which users receive it.
        </p>
        <app-scheduled-notifications
          [reportId]="AD_REPORT_ID"
          [reportTypeWire]="AD_REPORT_TYPE_WIRE">
        </app-scheduled-notifications>
      </section>

      <div class="ad-settings__actions">
        <button
          class="btn btn-primary btn-rounded btn-sm"
          (click)="onSave()"
          [disabled]="saving">
          {{ saving ? 'Saving…' : 'Save' }}
        </button>
      </div>

    </div>
  </ng-container>

</div>

<ng-template #loadingTpl>
  <div class="ad-settings__loading-state">
    <ngx-processing-anim [loader]="true"
      style="width: 17px; vertical-align: middle; padding-top: 5px; margin-left: 5px;"></ngx-processing-anim>
    Loading...
  </div>
</ng-template>
